define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/property/',
		url:function(){
			if(this.propertyType){
				var url = this.urlRoot;
				if(this.propertyType.toLowerCase() == 'parcel'){
					url+='parcels/';
				} else if (this.propertyType.toLowerCase()=='address'){
					url+='addresses/'
				} else {
					return '';
				}
				if(this.propertyID){
					url+=this.propertyID
				}
				return url;
			}
		},
		parse:function(response){
			if(this.propertyType.toLowerCase() == 'parcel'){
				response.data.type = 'Parcel'
			} else if (this.propertyType.toLowerCase()=='address'){
				response.data.type='Address'
			}
			return response.data;
		}
	});
});
